module.exports = __webpack_public_path__ + "img/tpc-14.d1b65e2e.webp";